import useProperty from '@/hooks/api/useProperty';

export const useCustomerLoyalty = () =>
    useProperty('Customer', 'getLoyalty', {
        boundEvents: ['logIn', 'logOut', 'updateLoyalty'],
    });

export const useVerifiedAt = () =>
    useProperty('Customer', 'getVerifiedAt', {
        boundEvents: ['logIn', 'logOut', 'updateVerifiedAt'],
    });

export const useGroupTab = () =>
    useProperty('Customer', 'getCurrentGroupTab', {
        boundEvents: [
            'groupTabLoadSuccess',
            'createGroupTabSuccess',
            'joinGroupTabSuccess',
            'closeGroupTabSuccess',
            'increaseGroupTabSuccess',
        ],
    });

export const useCustomerSuggestions = () =>
    useProperty('Customer', 'getCustomerSuggestions', {
        boundEvents: ['logIn', 'logOut', 'updateCustomerSuggestions']
        ,
        initialState: [],
    });

export const { requestVerification } = Mobi2Go.Customer;
export const { completeVerification } = Mobi2Go.Customer;
